import { render, staticRenderFns } from "./SubOrderDetails.vue?vue&type=template&id=6cc7c008&scoped=true"
import script from "./SubOrderDetails.vue?vue&type=script&lang=js"
export * from "./SubOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./SubOrderDetails.vue?vue&type=style&index=0&id=6cc7c008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc7c008",
  null
  
)

export default component.exports